// extracted by mini-css-extract-plugin
export default {"graphicGenders":"GraphicNPS_graphicGenders__pM7bF"};